import { render, staticRenderFns } from "./goods-list-item.vue?vue&type=template&id=6f5fcfda&scoped=true"
import script from "./goods-list-item.vue?vue&type=script&lang=js"
export * from "./goods-list-item.vue?vue&type=script&lang=js"
import style0 from "./goods-list-item.vue?vue&type=style&index=0&id=6f5fcfda&prod&lang=css"
import style1 from "./goods-list-item.vue?vue&type=style&index=1&id=6f5fcfda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5fcfda",
  null
  
)

export default component.exports